import React, { JSX } from 'react';

import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useTheme } from '@mui/material/styles';

type KitTableHeaderColor =
  | 'warning'
  | 'primary'
  | 'error'
  | 'success'
  | 'info'
  | 'gray';

interface KitTableProps {
  tableHeaderColor?: KitTableHeaderColor;
  tableHead?: Array<string | JSX.Element>;
  tableData: React.ReactNode[][];
  hover?: boolean;
  striped?: boolean;
}

export default function KitTable(props: KitTableProps) {
  const {
    tableHead,
    tableData,
    tableHeaderColor = 'gray',
    hover = false,
    striped = false,
  } = props;
  const theme = useTheme() as any;

  return (
    <Box sx={{ minHeight: '0.1%', overflowX: 'auto' }}>
      <Table
        sx={{
          marginBottom: '0',
          width: '100%',
          maxWidth: '100%',
          backgroundColor: 'transparent',
          borderSpacing: '0',
          borderCollapse: 'collapse',
          overflow: 'auto',
          '& > tbody > tr, & > thead > tr': {
            height: 'auto',
          },
        }}
      >
        {tableHead !== undefined ? (
          <TableHead>
            <TableRow>
              {tableHead.map((headerCell, key) => {
                return (
                  <TableCell
                    sx={[{
                      lineHeight: '1.5em',
                      padding: '12px 8px!important',
                      verticalAlign: 'middle',
                      borderBottom: 'none',
                      borderTop: '1px solid ' + theme.palette.grey[400],
                      position: 'relative',
                      fontSize: '1.063rem',
                      borderBottomWidth: '1px',
                      fontWeight: '300',
                      borderTopWidth: '0 !important'
                    }, tableHeaderColor === 'gray' ? {
                      color: theme.palette.grey[600]
                    } : {
                      color: `${theme.palette[tableHeaderColor as string].main}`
                    }]}
                    key={key}
                  >
                    {headerCell}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {tableData.map((row, key) => {
            return (
              <TableRow
                key={key}
                hover={hover}
                sx={{
                  backgroundColor:
                    striped && key % 2 === 0
                      ? theme.palette.grey[100]
                      : 'inherit',
                }}
              >
                {row.map((cell, key) => {
                  return (
                    <TableCell
                      sx={{
                        lineHeight: '1.5em',
                        padding: '12px 8px!important',
                        verticalAlign: 'middle',
                        fontSize: '0.875rem',
                        borderBottom: 'none',
                        borderTop: '1px solid ' + theme.palette.grey[400],
                        position: 'relative',
                        color: theme.palette.grey['A700'],
                      }}
                      key={key}
                    >
                      {cell}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Box>
  );
}
